// Author: Ozy
// Product Callsign Input Handler
// Validates required callsign field and prevents form submission if empty

class ProductCallsignInput {
  constructor(input) {
    this.input = input;
    this.container = input.closest('.product-callsign');
    this.errorContainer = this.container?.querySelector('.product-callsign__error');
    this.form = input.closest('form');
    
    if (!this.form) {
      console.error('[Callsign] No form found');
      return;
    }
    
    this.init();
  }
  
  init() {
    // Auto-uppercase callsigns as user types
    this.input.addEventListener('input', (e) => {
      const cursorPos = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      e.target.setSelectionRange(cursorPos, cursorPos);
      this.hideError();
    });
    
    // Validate on blur
    this.input.addEventListener('blur', () => {
      this.validate();
    });
    
    // Prevent form submission if invalid
    this.form.addEventListener('submit', (e) => {
      if (!this.validate()) {
        e.preventDefault();
        e.stopPropagation();
        this.input.focus();
        return false;
      }
    }, true); // Use capture phase to run before other handlers
    
    console.log('[Callsign] Initialized for input:', this.input.id);
  }
  
  validate() {
    const value = this.input.value.trim();
    
    if (!value) {
      this.showError('Please enter your call sign');
      return false;
    }
    
    // Optional: Basic callsign format validation (letters and numbers)
    const callsignPattern = /^[A-Z0-9]+$/;
    if (!callsignPattern.test(value)) {
      this.showError('Call sign should only contain letters and numbers');
      return false;
    }
    
    this.hideError();
    return true;
  }
  
  showError(message) {
    if (!this.errorContainer) return;
    
    const errorText = this.errorContainer.querySelector('.product-callsign__error-text');
    if (errorText) {
      errorText.textContent = message;
    }
    
    this.errorContainer.style.display = 'flex';
    this.input.setAttribute('aria-invalid', 'true');
    this.input.classList.add('error');
  }
  
  hideError() {
    if (!this.errorContainer) return;
    
    this.errorContainer.style.display = 'none';
    this.input.removeAttribute('aria-invalid');
    this.input.classList.remove('error');
  }
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', () => {
  const callsignInputs = document.querySelectorAll('[data-callsign-input]');
  
  callsignInputs.forEach(input => {
    new ProductCallsignInput(input);
  });
  
  console.log('[Callsign] Initialized', callsignInputs.length, 'input(s)');
});

// Reinitialize on theme editor section updates
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const callsignInputs = document.querySelectorAll('[data-callsign-input]');
    callsignInputs.forEach(input => {
      if (!input._callsignInitialized) {
        new ProductCallsignInput(input);
        input._callsignInitialized = true;
      }
    });
  });
}
